<select
  #inp
  class="selectpicker ch-header-item"
  [ngClass]="{ 'show-tick': showClass }"
  data-live-search="true"
  (change)="itemSelected($event)"
>
  <option *ngIf="nothingSelectedText" value disabled selected hidden style="display:none">{{ nothingSelectedText }}</option>
  <option *ngFor="let item of items" value="{{ item.id }}" data-token="" [selected]="value == item.id">{{ item.value }}</option>
</select>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/live-search/live-search.component.html